import { Component, ViewEncapsulation, Input, ViewChild, OnInit } from "@angular/core";
import { MatTabGroup } from "@angular/material/tabs";
import { SharedModule } from "@Shared/shared.module";
import Client from "@Models/global/client";
import Account from "@Models/config/account";
import { FeatureManagerService } from "@Services";
import { FeatureToggle } from "@Enums/feature-toggle.enum";
import WorkbenchV2OptionsConfigComponent from "./components/options/workbenchv2-options-config.component";
import WorkbenchV2RequirementsConfigComponent from "./components/workbenchv2-requirements-config.component";
import WorkbenchV2TasksConfigComponent from "./components/workbenchv2-tasks-config.component";

@Component({
    selector: 'workbenchv2-settings',
    templateUrl: './workbenchv2-settings.component.html',
    styleUrls: ['workbenchv2-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [SharedModule, WorkbenchV2RequirementsConfigComponent, WorkbenchV2OptionsConfigComponent, WorkbenchV2TasksConfigComponent]
})

export default class WorkbenchV2SettingsComponent implements OnInit{
    @Input() client: Client;
    @Input() account: Account;
    @Input() targetSubTab: string; // For deep linking to specific workbench tabs
    @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
    
    constructor(private featureManagerService: FeatureManagerService) {}
    selectedTabIndex = 0;
    isTasksEnabled = false;

    ngOnInit() {
        this.isTasksEnabled = this.featureManagerService.getByName(FeatureToggle.ConfigWorkbenchTasks)?.enabled;
    }
}